import { SVGProps } from "react";

export function OneIDSuccessIllustration(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width={88} height={88} viewBox="0 0 88 88" fill="none" {...props}>
      <circle cx={44} cy={44} r={36} fill="#DEDFE0" opacity={0.2} />
      <rect width={40} height={56} x={10} y={16} fill="#D5E8EA" rx={2} />
      <path
        fill="#AACFD3"
        d="M29.674 32.822C21.566 32.822 15 39.402 15 47.511c0 8.108 6.566 14.688 14.674 14.688 8.123 0 14.703-6.58 14.703-14.688s-6.58-14.689-14.703-14.689Zm10.18 8.813H35.52a22.984 22.984 0 0 0-2.027-5.229 11.794 11.794 0 0 1 6.36 5.23ZM29.688 35.82a20.693 20.693 0 0 1 2.805 5.816h-5.61a20.693 20.693 0 0 1 2.805-5.816Zm-11.37 14.63a12.107 12.107 0 0 1-.381-2.938c0-1.014.147-1.998.382-2.938h4.964c-.117.97-.205 1.939-.205 2.938 0 .998.088 1.968.205 2.937H18.32Zm1.205 2.937h4.333a22.991 22.991 0 0 0 2.027 5.23 11.732 11.732 0 0 1-6.36-5.23Zm4.333-11.75h-4.333a11.731 11.731 0 0 1 6.36-5.23 22.989 22.989 0 0 0-2.027 5.23Zm5.832 17.567a20.692 20.692 0 0 1-2.806-5.817h5.611a20.692 20.692 0 0 1-2.805 5.817Zm3.437-8.755h-6.874c-.133-.97-.235-1.938-.235-2.937 0-1 .102-1.983.235-2.938h6.874c.132.955.235 1.939.235 2.938 0 .998-.103 1.968-.235 2.937Zm.367 8.167a22.987 22.987 0 0 0 2.027-5.229h4.333a11.795 11.795 0 0 1-6.36 5.23Zm2.6-8.167c.117-.97.205-1.938.205-2.937 0-1-.088-1.969-.205-2.938h4.965c.235.94.382 1.924.382 2.938 0 1.013-.147 1.997-.382 2.937h-4.965Z"
      />
      <rect
        width={26}
        height={6}
        x={17}
        y={22}
        fill="#fff"
        opacity={0.9}
        rx={1}
      />
      <rect width={54} height={34} x={28} y={46} fill="#33777E" rx={2} />
      <rect
        width={42}
        height={3}
        x={34}
        y={71}
        fill="#fff"
        opacity={0.9}
        rx={1.5}
      />
      <rect
        width={26}
        height={3}
        x={50}
        y={64}
        fill="#fff"
        opacity={0.6}
        rx={1.5}
      />
      <rect
        width={26}
        height={3}
        x={50}
        y={58}
        fill="#fff"
        opacity={0.6}
        rx={1.5}
      />
      <rect
        width={26}
        height={3}
        x={50}
        y={52}
        fill="#fff"
        opacity={0.6}
        rx={1.5}
      />
      <rect
        width={12}
        height={15}
        x={34}
        y={52}
        fill="#fff"
        opacity={0.9}
        rx={2}
      />
      <circle cx={68.989} cy={21.011} r={6.833} fill="#fff" />
      <path
        fill="#1F9E80"
        d="M67.687 22.441 66 20.733a.947.947 0 0 0-.673-.256.998.998 0 0 0-.694.267.964.964 0 0 0-.277.694c0 .27.1.484.299.64l2.349 2.37c.174.2.4.3.675.3.276 0 .513-.1.712-.3l4.847-4.847a.865.865 0 0 0 .3-.662c0-.259-.1-.494-.296-.704a1.001 1.001 0 0 0-.707-.246 1 1 0 0 0-.684.267l-4.164 4.185ZM68.992 30a8.927 8.927 0 0 1-3.504-.696 8.919 8.919 0 0 1-2.873-1.919 8.927 8.927 0 0 1-1.919-2.87A8.905 8.905 0 0 1 60 21.014a8.982 8.982 0 0 1 2.62-6.375 9.063 9.063 0 0 1 2.868-1.933A8.77 8.77 0 0 1 68.985 12c1.24 0 2.41.235 3.508.704a9.049 9.049 0 0 1 2.873 1.927 9.034 9.034 0 0 1 1.93 2.87A8.833 8.833 0 0 1 78 21.013a8.765 8.765 0 0 1-.706 3.502 9.083 9.083 0 0 1-1.932 2.866 8.984 8.984 0 0 1-2.869 1.923 8.863 8.863 0 0 1-3.5.697Z"
      />
    </svg>
  );
}
